import { useMutation, useQueries, useQuery } from "react-query";
import { useSnackbar } from "@kitbird/core";
import { getUser } from "../../../../services/userAccountService";
import { getMasterDepartment } from "../../../../services/masterDepartmentService";
import { getPools } from "../../../../services/poolService";
import { getAreas } from "../../../../services/areaService";
import { jobTItleAPI } from "../../../../services/masterData/jobTitle";
import { getSegments } from "../../../../services/segmentService";
import { postUserPosition, updateUserPosition } from "../../../../services/userPositionService/userPositionService";
import { useUserPosition } from "../Provider";
import { getUserRoles } from "../../../../services/common/rbacService";

const useFormCreateUser = (nip?: string) => {
  const {
    setModal,
    setConfirmationModal,
    setSelectedRow,
    refetchTable,
  } = useUserPosition();

  const {
    data: listUser,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["user", nip],
    queryFn: () => {
      if (nip) {
        return getUser(nip);
      }
      return null;
    },
    enabled: !!nip,
  });

  const snackbar = useSnackbar();

  const [department, pools, areas, jobTitle, segments, userRoles] = useQueries([
    {
      queryKey: "get_departments",
      queryFn: getMasterDepartment,
    },
    {
      queryKey: "get_pools",
      queryFn: getPools,
    },
    {
      queryKey: "get_areas",
      queryFn: getAreas,
    },
    {
      queryKey: "get_job_titles",
      queryFn: jobTItleAPI.getList,
    },
    {
      queryKey: "get_segments",
      queryFn: getSegments,
    },
    {
      queryKey: "get_roles",
      queryFn: getUserRoles,
    },
  ]);

  const { data: listDepartment } = department;
  const { data: listPool } = pools;
  const { data: listAreas } = areas;
  const { data: listJobTitle } = jobTitle;
  const { data: listSegments } = segments;
  const { data: listRoles } = userRoles;

  const mutateUser = useMutation({
    mutationFn: postUserPosition,
    onSuccess: (data) => {
      if (data.responseCode === "Succeed") {
        snackbar.show("Berhasil menambahkan user", "success");
        setConfirmationModal(false);
        setModal("");
        refetchTable();
        return;
      }
      setConfirmationModal(false);
      snackbar.show(data.responseMessage || "Gagal menambahkan user", "error");
    },
    onError: () => {
      snackbar.show("Gagal menambahkan user", "error");
    },
  });

  const updateUser = useMutation({
    mutationFn: updateUserPosition,
    onSuccess: (data) => {
      if (data.responseCode === "Succeed") {
        snackbar.show("Berhasil mengubah user", "success");
        setConfirmationModal(false);
        setSelectedRow(undefined);
        setModal("");
        refetchTable();
        return;
      }
      setConfirmationModal(false);
      snackbar.show(data.responseMessage || "Gagal mengubah user", "error");
    },
    onError: () => {
      snackbar.show("Gagal mengubah user", "error");
    },
  });

  return {
    listUser,
    isLoading,
    error,
    listDepartment,
    listPool,
    listAreas,
    listJobTitle,
    listSegments,
    listRoles,
    mutateUser,
    updateUser,
  };
};

export default useFormCreateUser;
